class ngIcon extends HTMLElement
{
	constructor() {
		super();
		
		this.attachShadow({ mode: 'open' });
	}
	
	connectedCallback() {
		
		new MutationObserver((entries, observer) => {
			for (var entry  of entries) {
				if (entry.type != "attributes") continue;
				switch (entry.attributeName) {
				case "stroke":
					this.shadowRoot.querySelector("polyline").setAttribute(entry.attributeName, this.getAttribute(entry.attributeName));
					break;
					
				case "fill":
					this.shadowRoot.querySelector("circle,rect,svg").setAttribute(entry.attributeName, this.getAttribute(entry.attributeName));
					break;
					
				case "start-fill":
				case "end-fill":
					var startFill = this.getAttribute("start-fill") || "rgba(255, 255, 255, 0.85)";
					var endFill = this.getAttribute("end-fill") || "rgba(30, 30, 40, 0.85)";
					$(entry.target).css({
						//background: `radial-gradient(circle farthest-corner at 33% 33%, ${startFill} 0%, ${endFill} 80%), radial-gradient(circle farthest-corner at 45% 45%, rgba(0, 0, 0, 0) 50%, #000000 80%)`
						background: `radial-gradient(circle farthest-corner at 33% 33%, ${startFill} 0%, ${endFill} 80%), radial-gradient(circle farthest-corner at 45% 45%, rgba(0, 0, 0, 0) 50%, #000000 80%)`
					});
					break;
				}
			}
		}).observe(this, {
			childList: false,
			subtree: false,
			attributeOldValue: true,
		});
	};
}

class ngCheck extends ngIcon
{
	constructor() {
		super();
	}
	
	connectedCallback() {
		var size	= this.getAttribute("size") || "12";
		var stroke	= this.getAttribute("stroke") || "black";

		this.shadowRoot.innerHTML = `
			<style>
				:host {
					width: ${size}px;
					--border: 1px solid
				}
				
				polyline {
					fill: none;
					stroke-width: 2px;
				}
			</style>

			<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" fill="currentColor" viewBox="0 0 16 16">
			  <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
			</svg>
		`;
		
		super.connectedCallback();
	};
}

class ngRect extends ngIcon
{
	constructor() {
		super();
	}
	
	connectedCallback() {
		var size	= this.getAttribute("size") || "12";
		var fill	= this.getAttribute("fill") || "black";

		this.shadowRoot.innerHTML = `
			<style>
				:host {
				}
			</style>
			
			<svg viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
				<rect width="${size}" height="${size}" x="0" y="0" rx="0" ry="0" fill="#ccc" />
			</svg>
		`;
		
		super.connectedCallback();
	};
}

class ngCircle extends ngIcon
{
	constructor() {
		super();
	}
	
	connectedCallback() {
		var size	= Number(this.getAttribute("size") || 12);
		var round	= size / 2;
		var fill	= this.getAttribute("fill") || "black";
		var stroke	= this.getAttribute("stroke") || "#666";
		var strokeWidth	= Number(this.getAttribute("stroke-width") || 0);
		var cx = round + strokeWidth;
		var cy = round + strokeWidth;
		
		this.shadowRoot.innerHTML = `
			<style>
				:host {
				}
			</style>
			
			<svg viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
				<circle fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" cx="${cx}" cy="${cy}" r="${round}"/>
			</svg>
		`;
		
		super.connectedCallback();
	};
}

class ngSphere extends ngIcon
{
	constructor() {
		super();
	}
	
	connectedCallback() {
		var size = this.getAttribute("size") || "12";
		var startFill = this.getAttribute("start-fill") || "rgba(255, 255, 255, 0.85)";
		var endFill = this.getAttribute("end-fill") || "rgba(0, 0, 0, 0.85)";

		this.shadowRoot.innerHTML = `
			<style>
				:host {
					position: absolute;
					width: ${size}px;
					height: ${size}px;
					border-radius: 50%;
					background: radial-gradient(circle farthest-corner at 33% 33%, ${startFill} 0%, ${endFill} 80%), radial-gradient(circle farthest-corner at 45% 45%, rgba(0, 0, 0, 0) 50%, #000000 80%);
				}
			</style>
		`;
		
		super.connectedCallback();
	};
}

if (!customElements.get('ng-check')) {
	customElements.define("ng-check", ngCheck);
}

if (!customElements.get('ng-rect')) {
	customElements.define("ng-rect", ngRect);
}

if (!customElements.get('ng-circle')) {
	customElements.define("ng-circle", ngCircle);
}

if (!customElements.get('ng-sphere')) {
	customElements.define("ng-sphere", ngSphere);
}
